import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BxLogger } from '../../../../../core/services/bx-logger.service';
import { BxUnverifiedAlertService } from '../../../../../core/services/bx-unverified-alert.service';
import { DialogService } from '../../../../../core/services/dialog.service';
import { InvoiceSharingService } from '../../../../../core/services/invoice-sharing.service';
import { FeatureService } from '../../../../../core/services/permission/feature.service';
import { PermissionService } from '../../../../../core/services/permission/permission.service';
import { Job, JobPayment } from '../../../../../data/models';
import { RepoJobsService } from '../../../../../data/repositories/repo-jobs.service';
import { SharedDataService } from '../../../../../data/services/shared-data.service';
import { CustomLayoutsService } from '../../../../estimates/custom-layouts/custom-layouts.service';
import { InvoicesReceiptService } from '../../../invoices/invoices-receipt.service';
import { InvoicesService } from '../../../invoices/invoices.service';

@Component({
    selector: 'app-job-invoices-deposit',
    templateUrl: './job-invoices-deposit.component.html',
    standalone: false,
})
export class JobInvoicesDepositComponent implements OnInit, OnChanges {
    // @ts-ignore TS2564
    @Input() job: Job;
    @Output() invoiceChange = new EventEmitter();
    depositRows: JobPayment[] = [];
    tableHeight = 'auto';
    depositTableHeight = 'auto';
    lastSharedInvoiceStatus = '';
    generatingPDF = false;
    pdfUrl = '';

    constructor(
        private bxUnverifiedAlertService: BxUnverifiedAlertService,
        private invoiceSharingService: InvoiceSharingService,
        public permissionService: PermissionService,
        public featureService: FeatureService,
        private logger: BxLogger,
        private invoicesService: InvoicesService,
        private invoicesReceiptService: InvoicesReceiptService,
        private customLayoutsService: CustomLayoutsService,
        private sharedData: SharedDataService,
        private repoJobs: RepoJobsService,
        private dialogService: DialogService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.job) this.load();
    }

    ngOnInit(): void {
        if (this.job) this.load();
    }

    load() {
        // @ts-ignore TS2532
        this.depositRows = this.job.JobPayments.filter((p) => {
            return !p.IsDeleted && p.IsDepositInvoice;
        });
        this.depositTableHeight = this.depositRows.length * 42 + 52 + 52 + 'px';
    }

    viewInvoice(invoice: JobPayment) {
        this.invoicesService.viewInvoice(invoice).then(
            () => this.load(),
            (error) => ({})
        );
    }

    addDepositInvoice() {
        // Cannot add depsoit if one already exists
        if (
            // @ts-ignore TS2532
            this.job.JobPayments.some((i) => {
                return !i.IsDeleted && i.IsDepositInvoice;
            })
        ) {
            this.dialogService.show({
                type: 'info',
                title: 'Cannot add another deposit',
                text: 'You already have an invoice, unable to add another',
                showCancel: false,
            });
            return;
        }

        this.invoicesService.newDeposit(this.job).then(() => {
            this.load();
            this.invoiceChange.emit();
        });
    }

    deleteInvoice(evt: MouseEvent, invoice: JobPayment) {
        evt.stopPropagation();
        const params = {
            title: 'Delete invoice?',
            text: "If you go ahead, you won't be able to get it back.",
        };
        this.dialogService.show(params).then(
            () => {
                invoice.IsDeleted = true;
                this.repoJobs.Save(null, 'Invoice has been deleted');
                this.load();
                this.invoiceChange.emit();
            },
            () => ({})
        );
    }

    printInvoice(invoice: JobPayment) {
        this.invoicesService.generateInvoice(invoice, undefined, true);
    }

    shareInvoice(invoice: JobPayment) {
        this.lastSharedInvoiceStatus = invoice.Status;
        const documentSource = { Id: this.job.ID_Job, Type: 'Job' };
        this.invoiceSharingService.getEmailConfig(invoice, 'pdf').then((emailConfig) => {
            const shareConfig = this.invoiceSharingService.getShareConfig(invoice);
            this.customLayoutsService.openDigitalAcceptanceShareForm(
                emailConfig,
                shareConfig,
                null,
                true,
                3,
                false,
                this.job.ID_Lead,
                documentSource,
                true,
                invoice,
                () => {
                    this.handleShareSuccess();
                },
                () => {
                    this.resetInvoiceStatus(invoice);
                }
            ); // 3 : DocumentTypes.Invoice
        });
    }

    // TODO:: move to shared component to slim the product
    emailInvoice(invoice: JobPayment) {
        if (!this.sharedData.UserData.identityInfo.email_verified) {
            this.bxUnverifiedAlertService.trigger(this.sharedData.UserData.user);
            return;
        }

        this.invoicesService.emailInvoice(invoice).then(
            () => {
                this.load();
                this.invoiceChange.emit();
            },
            () => ({})
        );
    }

    addReceipt(invoice: JobPayment) {
        this.invoicesReceiptService.addReceipt(invoice).then(
            () => {
                this.repoJobs.Save(null, 'Receipt saved').then(() => {
                    this.invoiceChange.emit();
                });
            },
            () => {
                invoice.entityAspect.rejectChanges();
            }
        );
    }

    handleShareSuccess() {
        this.logger.success('Invoice Shared');
    }

    resetInvoiceStatus(invoice: JobPayment) {
        if (this.lastSharedInvoiceStatus !== invoice.Status) {
            invoice.Status = this.lastSharedInvoiceStatus;
            this.invoicesService.setInvoiceNumber(invoice).then((invoiceWithId) => {
                this.invoicesService.saveInvoice(invoiceWithId);
                this.invoiceChange.emit();
            });
        }
    }
}
